<template>
          <SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
          <div class="dashboard-layout">
          <div class="content-container">
            <div class="card-container">

              <div class="titolo-card">
      <h1>Tickets risposti</h1>
    </div>

    <div class="loader" v-if="isLoading">
          <h4>RECUPERO DEI TICKETS IN CORSO</h4>
        </div>

    <div class="search-email-container">
          <input type="text" v-model="searchEmail" placeholder="Cerca per email utente...">
        </div>

 <!-- Sezione per i Ticket Risposti -->
 <div class="tickets">

    <div>
      <table>
        <thead>
          <tr>
            <th>TITOLO</th>
            <th>DATA</th>
            <th>STATUS</th>
            <th>EMAIL</th>
            <th>STUDIO</th> <!-- Aggiungi questa colonna -->
            <th>AZIONI</th>
          </tr>
        </thead>
        <tbody>
          <!-- Assicurati di utilizzare paginatedTickets qui -->
          <tr v-for="ticket in paginatedTickets" :key="ticket.id">
            <td>{{ truncateTitle(ticket.title, 20) }}</td>
            <td>{{ ticket.date }}</td>
            <td>{{ ticket.status }}</td>
            <td>{{ ticket.userEmail }}</td>
            <td>{{ ticket.studioName }}</td> <!-- Visualizza il nome dello studio -->
            <td>
                    <button :disabled="ticket.read === 'true' || ticket.read === true"
                            :class="{
                              'green': ticket.status === 'Risposto' && !(ticket.read === 'true' || ticket.read === true),
                              'orange': ticket.status === 'Aperto' && !(ticket.read === 'true' || ticket.read === true),
                              'red': ticket.status === 'Completato' && !(ticket.read === 'true' || ticket.read === true),
                              'purple': ticket.read === 'true' || ticket.read === true
                            }"
                            @click.stop="viewConversation(ticket.id)">
                      <span class="material-icons">chevron_right</span>
                    </button>
                  </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Bottoni di paginazione -->
  <div class="pagination">
    <button 
      :disabled="currentPage <= 1" 
      @click="prevPage">Prec.</button>

    <!-- Mostra il numero della pagina corrente -->
    <span> Pagina {{ currentPage }} di {{ pageCount }}</span>

    <button 
      :disabled="currentPage >= pageCount" 
      @click="nextPage">Succ.</button>
  </div>

  </div>
  </div>
  </div>
</template>


  
  
<script>
import { ref, computed, onMounted } from 'vue';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { useRouter } from 'vue-router';
import { getAuth, signOut } from "firebase/auth";
import SidebarComponent from '../SidebarComponent.vue'; // Importa SidebarComponent

export default {
  components: {
    SidebarComponent // Registra il componente SidebarComponent
  },

  setup() {
    const tickets = ref([]);
    const isLoading = ref(false); // Aggiunto per il loader
    const router = useRouter();
    const searchEmail = ref('');
    const currentPage = ref(1);
    const ticketsPerPage = ref(15);

    const truncateTitle = (title, maxLength) => {
      return title.length > maxLength ? title.substring(0, maxLength) + "..." : title;
    };


    const paginatedTickets = computed(() => {
      const start = (currentPage.value - 1) * ticketsPerPage.value;
      const end = start + ticketsPerPage.value;
      return filteredTickets.value.slice(start, end);
    });

    const pageCount = computed(() => {
      return Math.ceil(filteredTickets.value.length / ticketsPerPage.value);
    });

    const nextPage = () => {
      if (currentPage.value < pageCount.value) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };


    const answeredAndCompletedTickets = computed(() => {
      return tickets.value
        .filter(ticket => ticket.status === 'Risposto' || ticket.status === 'Completato')
        .sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
    });

    const filteredTickets = computed(() => {
      if (searchEmail.value) {
        return tickets.value.filter(ticket => 
          ticket.userEmail.toLowerCase().includes(searchEmail.value.toLowerCase())
        );
      }
      return answeredAndCompletedTickets.value;
    });

    const viewConversation = (ticketId) => {
      router.push({ name: 'AdminTicketConversation', params: { ticketId } });
    };

    const goToOpenTickets = () => {
  router.push('/admin');
};


const fetchTickets = async () => {
  isLoading.value = true; // Avvia il loader

  const db = getFirestore();
  const ticketsCollection = collection(db, 'tickets');
  const usersCollection = collection(db, 'users');
  const studiCollection = collection(db, 'studi');

  const userSnapshot = await getDocs(usersCollection);
  const userEmails = {};
  const userStudios = {};
  userSnapshot.forEach((doc) => {
    const userData = doc.data();
    userEmails[doc.id] = userData.email;
    userStudios[doc.id] = userData.parent_id;
  });

  const studiSnapshot = await getDocs(studiCollection);
  const studi = {};
  studiSnapshot.forEach((doc) => {
    studi[doc.data().parent_id] = doc.data().name;
  });

  try {
    const querySnapshot = await getDocs(ticketsCollection);
    const ticketList = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const userEmail = userEmails[data.userId] || 'Email sconosciuta';
      
      // Verifica se esiste un parent_id e se corrisponde a un nome di studio
      const userParentId = userStudios[data.userId];
      const studioName = (userParentId && studi[userParentId]) ? studi[userParentId] : 'NO STUDIO';

      // Trova l'ultimo aggiornamento nella conversazione
      let lastUpdateDateFormatted = '';
      if (data.conversations && data.conversations.length > 0) {
        const lastUpdateTimestamp = data.conversations.reduce((latest, current) => {
          const currentTimestamp = new Date(current.timestamp);
          return currentTimestamp > latest ? currentTimestamp : latest;
        }, new Date(0));
        lastUpdateDateFormatted = lastUpdateTimestamp.toLocaleDateString('it-IT');
      }

      ticketList.push({ 
        id: doc.id, 
        ...data, 
        date: lastUpdateDateFormatted,  // Usa la data dell'ultimo aggiornamento
        userEmail,
        studioName  // Aggiungi il nome dello studio
      });
    });

    // Ordina i ticket in base alla data dell'ultimo aggiornamento
    tickets.value = ticketList.sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch (error) {
    console.error('Errore nel recupero dei ticket:', error);
  } finally {
    isLoading.value = false; // Ferma il loader
  }
};




    const handleLogout = async () => {
      const auth = getAuth();
      try {
        await signOut(auth);
        router.push('/');
      } catch (error) {
        console.error("Errore durante il logout:", error);
      }
    };

    onMounted(fetchTickets);

    return {
      tickets,
      handleLogout,
      viewConversation,
      answeredAndCompletedTickets,
      goToOpenTickets,
      searchEmail,  // Aggiungi questa linea
      filteredTickets,  // Aggiungi questa linea
      currentPage,
      paginatedTickets,
      nextPage,
      prevPage,
      pageCount,
      truncateTitle,
      isLoading
    };
  },
};

</script>



<style scoped>

.pagination {
text-align: center;
margin-top: 20px;
color: #3f3f3f;

}

input[type="text"] {
  border-radius: 24px;  /* Angoli stondati */
  background-color: #f1f1f116;  /* Sfondo grigio */
  padding: 11px;  /* Spazio interno */
  border: 1px solid #4c4c4c;  /* Bordo */
  color:rgb(211, 211, 211)
}


.search-email-container {
  color:#4c4c4c;
}

.material-icons {
  margin-left: 0px;
  margin-right: 0px;
}


</style>
